import { render, staticRenderFns } from "./TextColumn.vue?vue&type=template&id=534c19b8&scoped=true&"
import script from "./TextColumn.vue?vue&type=script&lang=ts&"
export * from "./TextColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c19b8",
  null
  
)

export default component.exports